import { cleanTitle } from "components/Contentful/RichTextRenderer/RichTextRenderer.utils"
import { PlusIcon, MinusIcon } from "components/SVG"
import { cmsPageClick } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import { Toggleable } from "packages/ui-shared/components/Toggleable/Toggleable"
import React from "react"
import type { ReducedFAQSection } from "types/cms"
import { createMarkup } from "utils/createMarkup"

import {
  containerColors,
  innerContainer,
  questionContainer,
  questionItem,
  plusIcon,
  minusIcon,
  answerContainer,
} from "./FAQs.css"

type Props = CMSPageProps & ReducedFAQSection

const HeaderSize = ({ headingSize, heading }) => {
  const TagSize = headingSize
  return <TagSize id={cleanTitle(heading)}>{heading}</TagSize>
}

const handleClick = (
  trackingModule: CMSPageProps["trackingModule"],
  question: string
) => {
  cmsPageClick({
    ...trackingModule,
    moduleContentDetails: question,
  })
}

export const FAQs: React.FC<Props> = ({
  bgColor,
  trackingModule,
  heading,
  questions,
}) => {
  const { modulePosition } = trackingModule
  return (
    <div id="faqs" className={containerColors[bgColor ?? "White"]}>
      <div className={innerContainer}>
        <HeaderSize
          headingSize={modulePosition === 1 ? "h1" : "h2"}
          heading={heading || "Title"}
        />
        <div>
          {questions.map((question, index) => {
            return (
              <div
                className={questionContainer}
                key={`${question.title}-${index}`}
              >
                <Toggleable
                  onClick={() => handleClick(trackingModule, question.title)}
                  triggerItem={
                    <div className={questionItem}>
                      <h5>{question.title}</h5>
                      <PlusIcon
                        className={plusIcon}
                        viewBox="3 3 18 18"
                        width="18"
                        height="18"
                      />
                      <MinusIcon
                        className={minusIcon}
                        viewBox="3 3 18 18"
                        width="18"
                        height="18"
                      />
                    </div>
                  }
                  contentItem={
                    <div
                      className={answerContainer}
                      dangerouslySetInnerHTML={createMarkup(question.answer)}
                    />
                  }
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
